module.exports = __webpack_public_path__ + "img/add--filled 2.bc72852d.svg";